exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-rich-box[data-v-4c26c552]  img{height:auto !important;max-width:100% !important;disblay:block !important;margin:0 auto !important}", ""]);

// exports
